@if (loader === ProcessingState.Loading) {
  <div class="mb-0 custom-table horizontal-scroll" [class.table-responsive]="tableResponsive">
    <table class="table mb-0">
      <tbody>
        <tr class="table-row" *ngFor="let row of skeleton">
          <th
            *ngFor="let col of tableView?.head || []; let i = index"
            [ngClass]="{
              'checkbox first-td checkbox-control': col.type === 'checkbox',
              'pe-0 pull-right control-btn': col.type === 'actions',
            }">
            @if (col.type === 'checkbox') {
              <ngx-skeleton-loader
                appearance="line"
                animation="pulse"
                class="skeleton-loader"
                [theme]="{ width: '20px', height: '20px' }"></ngx-skeleton-loader>
            }

            @if (col.type === 'actions') {
              <ngx-skeleton-loader
                appearance="line"
                animation="pulse"
                class="skeleton-loader"
                [theme]="{ width: '20px', height: '20px' }"></ngx-skeleton-loader>
            }

            @if (col.type !== 'checkbox' && col.type !== 'actions') {
              <ngx-skeleton-loader
                appearance="line"
                animation="pulse"
                class="skeleton-loader"
                width="'100%'"
                height="'20px'"></ngx-skeleton-loader>
            }
          </th>
        </tr>
      </tbody>
    </table>
  </div>
}

@if (loader === ProcessingState.Success && tableView.rows.length) {
  <!--  <pre>
    {{tableView.head | json}}
  </pre>-->
  <div
    class="mb-0 custom-table table-fullview table-list-view scroll-heading horizontal-scroll"
    [class.table-responsive]="tableResponsive">
    <table class="table mb-0">
      <thead class="table-heading">
        <tr class="table-row">
          <ng-container *ngFor="let col of tableView.head; let i = index; trackBy: trackByColumn">
            <th
              *ngIf="col.isShow"
              [class.row-size]="compactTable"
              [class.table-style]="logStyle"
              [ngClass]="{
                'checkbox first-td checkbox-control': col.type === 'checkbox',
                'pe-0 pull-right control-btn': col.type === 'actions',
              }"
              class="cursor-pointer h4-reg checkbox first-td checkbox-control">
              <app-checkbox
                class="select-checkbox"
                *ngIf="col.type === 'checkbox'"
                [id]="'checkbox' + i"
                [checked]="col.isChecked || false"
                [disabled]="col.disabled || false"
                [indeterminate]="col.isCheckIndeterminate || false"
                (onCheckChange)="
                  col.isChecked = $event!; onCheckboxClick('header-checkbox', col, $event)
                "></app-checkbox>

              <div *ngIf="col.type === 'actions'" class="action-btn overflow-hidden">
                <app-action-btn
                  (click)="isOpen = !isOpen"
                  cdkOverlayOrigin
                  #trigger="cdkOverlayOrigin"
                  cdkConnectedOverlayPanelClass="example-panel"
                  class="cursor-pointer"
                  [active]="false"
                  IconType="add"></app-action-btn>
                <ng-template
                  cdkConnectedOverlay
                  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                  [cdkConnectedOverlayHasBackdrop]="true"
                  (detach)="isOpen = false"
                  (backdropClick)="isOpen = false"
                  [cdkConnectedOverlayOrigin]="trigger"
                  [cdkConnectedOverlayOpen]="isOpen"
                  [cdkConnectedOverlayPositions]="[
                    {
                      originX: 'end',
                      originY: 'bottom',
                      overlayX: 'end',
                      overlayY: 'top',
                    },
                    {
                      originX: 'end',
                      originY: 'top',
                      overlayX: 'end',
                      overlayY: 'bottom',
                    },
                  ]">
                  <app-table-property
                    tabindex="0"
                    [dropdown]="tableView.head"
                    (custom_click)="onClick.emit($event)"
                    (onChange)="handlePropertyChange($event)"></app-table-property>
                </ng-template>
              </div>

              <span class="sort" *ngIf="!['actions', 'checkbox'].includes(col.type)"
                >{{ col.label
                }}<app-action-btn
                  *ngIf="col.sortable"
                  [active]="col.isSortActive || false"
                  [IconType]="col.sortOrder === 'asc' ? 'caret_up' : 'caret_down'"
                  (custom_click)="sort(col, true)"></app-action-btn
              ></span>
            </th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of tableView.rows; let i = index; trackBy: trackByRow"
          [class.hightlist-row1]="i === highlightedRowIndex"
          class="table-row">
          <ng-container *ngFor="let col of row; let colindex = index; trackBy: trackByColumn">
            <td
              *ngIf="showColumn(col.column)"
              [ngClass]="{
                'cursor-pointer checkbox-control': col.type === 'checkbox',
                'pe-0 control-btn': col.type === 'actions',
                status: col.type === 'badges',
              }"
              [class.row-size]="compactTable"
              [class.table-style]="logStyle"
              class="name h3-reg">
              <app-checkbox
                *ngIf="col.type === 'checkbox'"
                class="select-checkbox"
                [id]="'store4' + i"
                [checked]="col.isChecked"
                [disabled]="false"
                [indeterminate]="false"
                (onCheckChange)="
                  col.isChecked = $event!; onCheckboxClick('row-checkbox', col, $event)
                "></app-checkbox>

              <div
                app-table-data
                [Type]="col.type"
                [data]="col"
                (onClick)="onClick.emit($event)"
                (onChange)="
                  onChange.emit({ event: $event, col: colindex, row: i });
                  col?.['onChange']?.($event)
                "></div>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
}
@if (loader === ProcessingState.Error) {
  <app-error-state [errorMessage]="errorMessage"></app-error-state>
}

@if (loader === ProcessingState.Success && !tableView.rows.length) {
  <app-no-data [message]="noDataMessage"></app-no-data>
}

<!-- <app-no-data *ngIf="table_schema.rows.length === 0"></app-no-data> -->
